import React, { FC, PropsWithChildren, useRef, useState } from 'react';

import { fc } from 'i18n';
import { ReactPortal } from 'components/molecules/react-portal';

import styles from './styles.module.css';

interface ITooltipProps {
  text: string;
  className?: string;
}

export const Tooltip: FC<PropsWithChildren<ITooltipProps>> = ({ children, text, className }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState<Record<string, number>>({ top: 0, left: 0 });

  const onMouseOver = () => {
    if (wrapperRef.current) {
      const { top, left } = wrapperRef.current.getBoundingClientRect();

      setPosition({ top: top + 28, left: left + 22 });
      setIsVisible(true);
    }
  };

  const onMouseOut = () => setIsVisible(false);

  return (
    <div ref={wrapperRef} className={className || ''} onMouseOut={onMouseOut} onMouseOver={onMouseOver}>
      {children}
      <ReactPortal>
        {isVisible ? (
          <div className={styles.wrapper} style={{ ...position }}>
            {fc(text)}
          </div>
        ) : (
          <div />
        )}
      </ReactPortal>
    </div>
  );
};
